import React from "react";
import { ArrowSVG } from "src/assets/svg";

const StaticMenuCard = (props) => {
  const { image, title, choosen, isOpen } = props;
  return (
    <div className="flex items-center justify-between pl-51.5px h-35px cursor-pointer">
      <div className="flex items-center">
        {image}
        <div
          className={`text-lg ml-19.5px font-bold ${
            choosen ? "text-light-blue" : "text-light-gray"
          }`}>
          {title}
        </div>
      </div>
      {title === "Channel" && (
        <div className="pr-51.5px">
          <div className={isOpen ? "" : "transform rotate-180"}>
            <ArrowSVG width={12} height={7} fill={choosen ? "#545DFF" : "#7A7A7A"} />
          </div>
        </div>
      )}
      {choosen && title !== "Channel" && (
        <div className="bg-light-blue text-light-blue w-1.5 h-full rounded-l-2xl">|</div>
      )}
    </div>
  );
};

export default StaticMenuCard;
